import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar.jsx";
import { Topbar } from "./Topbar.jsx";
import { useUiStore } from "../../store/ui.store.js";
import { cn } from "../../lib/cn.js";

/**
 * Outer admin shell — sidebar + topbar + scrollable main.
 *
 * Pages render the breadcrumbs themselves by stashing them on the outlet
 * context: <Outlet context={{ setBreadcrumbs }} />. We could pull from a
 * Zustand slice but keeping breadcrumbs page-local is simpler.
 */
export function AdminLayout() {
  const collapsed = useUiStore((s) => s.sidebarCollapsed);
  return (
    <div className="min-h-screen bg-bg-base">
      <Sidebar />
      <div
        className={cn(
          "flex min-h-screen flex-col transition-[padding] duration-200",
          collapsed ? "pl-16" : "pl-60"
        )}
      >
        <Topbar />
        <main className="flex-1 px-6 py-6 lg:px-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
